import React from 'react'

import Typography from 'src/lib/ui/Typography'

import styles from './errorComponent.module.sass'

const ErrorComponent = () => (
  <Typography type="subheading" className={styles.errorTitle}>
    Something went wrong. Please refresh the page and try again.
  </Typography>
)

export default ErrorComponent
